import HealthStatusChip from "Components/molecule/health-status-chip"
import { ProjectHealth, ProjectHealthUI } from "models/project-health"

interface ProjectHealthSummaryProps {
    health: ProjectHealth | null
    isLoading: boolean
}

// Overall Project Health status and the checks behind it, shown in the project header card.
const ProjectHealthSummary = ({ health, isLoading }: ProjectHealthSummaryProps) => {
    if (isLoading) return <span className="text-muted"><i className="mdi mdi-loading mdi-spin me-1" />Checking health…</span>
    if (!health) return null

    const color = ProjectHealthUI.color(health.status)

    return (
        <div className={`project-health-summary border-${color}`}>
            <div className="d-flex flex-wrap align-items-center gap-2">
                <span className="fw-semibold">Project Health:</span>
                <HealthStatusChip status={health.status ?? null} />
                <span className="text-muted">{ProjectHealthUI.headline(health.status, health.failingChecks.length)}</span>
            </div>
            {health.failingChecks.length > 0 && (
                <ul className="reasons">
                    {health.failingChecks.map(c => (
                        <li key={c.key}>
                            <strong className={`text-${ProjectHealthUI.color(c.status)}`}>{c.label}:</strong> {c.message}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}

export default ProjectHealthSummary
